import React from "react";
import { useLocation } from "react-router-dom";
import Pahalgam from "../Component/Destination/Pahalgam";
import Srinagar from "../Component/Destination/Srinagar";

import Mussoorie from "../Component/Destination/Mussoorie";
import JimCorbett from "../Component/Destination/JimCorbett";
import Nainital from "../Component/Destination/Nainital";
import Assam from "../Component/Destination/Assam";
import Shimla from "../Component/Destination/Shimla";
import Manali from "../Component/Destination/Manali";
import Dalhousie from "../Component/Destination/Dalhousie";
import Gangtok from "../Component/Destination/Gangtok";
import Kalkata from "../Component/Destination/Kalkata";
import Puri from "../Component/Destination/Puri";
import Chandigarh from "../Component/Destination/Chandigarh";
import Amritsar from "../Component/Destination/Amritsar";
import Agra from "../Component/Destination/Agra";
import Haridwar from "../Component/Destination/Haridwar";
import Kanha from "../Component/Destination/Kanha";
import Diu from "../Component/Destination/Diu";
import Daman from "../Component/Destination/Daman";
import Saputara from "../Component/Destination/Saputara";
import Gir from "../Component/Destination/Gir";
import Kutch from "../Component/Destination/Kutch";
import Lonavala from "../Component/Destination/Lonavala";
import Mahabaleshwar from "../Component/Destination/Mahabaleshwar";
import Goa from "../Component/Destination/Goa";
import Banglore from "../Component/Destination/Banglore";
import Coorg from "../Component/Destination/Coorg";
import Munnar from "../Component/Destination/Munnar";
import Alleppy from "../Component/Destination/Alleppy";
import Thekkadi from "../Component/Destination/Thekkadi";
import Ooty from "../Component/Destination/Ooty";
import Rameshwaram from "../Component/Destination/Rameshwaram";
import Udaipur from "../Component/Destination/Udaipur";
import Kumbhalgarh from "../Component/Destination/Kumbhalgarh";
import Jaisalmer from "../Component/Destination/Jaisalmer";
import Pushkar from "../Component/Destination/Pushkar";
import Jodhpur from "../Component/Destination/Jodhpur";
import Dubai from "../Component/Destination/Dubai";
import Bali from "../Component/Destination/Bali";
import Krabi from "../Component/Destination/Krabi";
import California from "../Component/Destination/California";
import SriLanka from "../Component/Destination/SriLanka";
import Malaysia from "../Component/Destination/Malaysia";
import Maldives from "../Component/Destination/Maldives";
import Switzerland from "../Component/Destination/Switzerland";
import Phuket from "../Component/Destination/Phuket";
import Amsterdam from "../Component/Destination/Amsterdam";
import Budapest from "../Component/Destination/Budapest";
import Australia from "../Component/Destination/Australia";
import Paris from "../Component/Destination/Paris";

import AndamanNikoobar from "../Component/Destination/AndamanNikoobar";
import MountAbu from "../Component/Destination/Mountabu";

const Destinations = ({ data }) => {
  console.log(data);
  return (
    <>
      {data === "pahalgam" ? (
        <Pahalgam />
      ) : data === "srinagar" ? (
        <Srinagar />

      ) : data === "mussoorie" ? (
        <Mussoorie />
      ) : data === "jimcorbett" ? (
        <JimCorbett />
      ) : data === "nainital" ? (
        <Nainital />
      ) : data === "assam" ? (
        <Assam />
      ) : data === "shimla" ? (
        <Shimla />
      ) : data === "manali" ? (
        <Manali />
      ) : data === "dalhousie" ? (
        <Dalhousie />
      ) : data === "gangtok" ? (
        <Gangtok />
      ) : data === "kalkata" ? (
        <Kalkata />
      ) : data === "puri" ? (
        <Puri />
      ) : data === "chandigarh" ? (
        <Chandigarh />
      ) : data === "amritsar" ? (
        <Amritsar />
      ) : data === "agra" ? (
        <Agra />
      ) : data === "haridwar" ? (
        <Haridwar />
      ) : data === "kanha" ? (
        <Kanha />
      ) : data === "diu" ? (
        <Diu />
      ) : data === "daman" ? (
        <Daman />
      ) : data === "saputara" ? (
        <Saputara />
      ) : data === "gir" ? (
        <Gir />
      ) : data === "kutch" ? (
        <Kutch />
      ) : data === "lonavala" ? (
        <Lonavala />
      ) : data === "mahabaleshwar" ? (
        <Mahabaleshwar />
      ) : data === "goa" ? (
        <Goa />
      ) : data === "banglore" ? (
        <Banglore />
      ) : data === "coorg" ? (
        <Coorg />
      ) : data === "munnar" ? (
        <Munnar />
      ) : data === "alleppy" ? (
        <Alleppy />
      ) : data === "thekkadi" ? (
        <Thekkadi />
      ) : data === "ooty" ? (
        <Ooty />
      ) : data === "rameshwaram" ? (
        <Rameshwaram />
      ) : data === "udaipur" ? (
        <Udaipur />
      ) : data === "kumbhalgarh" ? (
        <Kumbhalgarh />
      ) : data === "jaisalmer" ? (
        <Jaisalmer />
      ) : data === "pushkar" ? (
        <Pushkar />
      ) : data === "jodhpur" ? (
        <Jodhpur />
      ) : data === "dubai" ? (
        <Dubai />
      ) : data === "bali" ? (
        <Bali />
      ) : data === "krabi" ? (
        <Krabi />
      ) : data === "california" ? (
        <California />
      ) : data === "srilanka" ? (
        <SriLanka />
      ) : data === "malaysia" ? (
        <Malaysia />
      ) : data === "maldives" ? (
        <Maldives />
      ) : data === "switzerland" ? (
        <Switzerland />
      ) : data === "phuket" ? (
        <Phuket />
      ) : data === "amsterdam" ? (
        <Amsterdam />
      ) : data === "budapest" ? (
        <Budapest />
      ) : data === "australia" ? (
        <Australia />
      ) : data === "paris" ? (
        <Paris />
      ) : data === "andaman&nicobar" ? (
        <AndamanNikoobar />
      ) : data === "mountabu" ? (
        <MountAbu />
      ) : null}
    </>
  );
};

export default Destinations;
